export default __webpack_public_path__ + "static/media/share.188548a0.svg";